import { createSlice } from "@reduxjs/toolkit";
import * as PostApi from "../api/post";
const posts = createSlice({
  name: "posts",
  initialState: {
    loading: false,
    error: null,
    list: [],
    summary: null,
  },
  reducers: {
    setLoading: (state) => {
      state.error = null;
      state.loading = true;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    getListSuccess: (state, action) => {
      state.list = action.payload.docs;
      state.summary = action.payload.summary;
      state.loading = false;
    },
    addPostSuccess: (state, action) => {
      state.list = [action.payload, ...state.list];
    },
    updatePostSuccess: (state, action) => {
      console.log(action.payload);
      state.list = state.list.map((post) => {
        if (post._id === action.payload._id) {
          return action.payload;
        } else {
          return post;
        }
      });
    },
    deletePostSuccess: (state, action) => {
      state.list = state.list.filter(
        (item) => action.payload?._id !== item._id
      );
    },
  },
});

export const getListPost = (params) => async (dispatch) => {
  try {
    dispatch(setLoading());
    const res = await PostApi.getListPost(params);
    dispatch(getListSuccess(res));
  } catch (error) {
    dispatch(setError(error));
  }
};

const { reducer, actions } = posts;
export const {
  setLoading,
  setError,
  getListSuccess,
  addPostSuccess,
  deletePostSuccess,
  updatePostSuccess,
} = actions;
export default reducer;
